import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=7836c000&scoped=true"
import script from "./text-field.vue?vue&type=script&lang=js"
export * from "./text-field.vue?vue&type=script&lang=js"
import style0 from "./text-field.vue?vue&type=style&index=0&id=7836c000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836c000",
  null
  
)

export default component.exports